import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { Component, Inject, OnInit, ChangeDetectionStrategy } from "@angular/core";

import { TranslateModule } from "@ngx-translate/core";
import { FilterEditorComponent } from "../editor/filter-editor.component";
import { FormsModule } from "@angular/forms";
import { StatsService } from "../../analytics/stats/stats.service";
import { FilterCodec } from "@teammood/filter";
import { CompositeFilter } from "../filter.type";

@Component({
    selector: 'filter-dialog',
    templateUrl: './filter-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
    FormsModule,
    TranslateModule,
    MatDialogModule,
    FilterEditorComponent
]
})
export class FilterDialogComponent implements OnInit{

    namedFilter: any;
    availableOrgUnits: any;
    mode: 'update' | 'create';
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: FilterData,
        public dialogRef: MatDialogRef<FilterDialogComponent>,
        private statsService: StatsService,
        private filterCodec: FilterCodec
    ) { }

    async ngOnInit() {
        this.namedFilter = this.data.namedFilter;
        this.mode = this.data.mode;
        this.availableOrgUnits = await this.statsService.all_org_units();
    }

    cancel() {
        this.dialogRef.close();
    }
    save(filter) {
        const data = {
            filter: filter,
            mode: this.mode
        }
        this.dialogRef.close(data);
    }
    save_filters(predicates) {
        this.namedFilter.decodedFilter = predicates;
        this.namedFilter.filter = this.filterCodec.encode(predicates);
    }
}

export interface FilterData {
    namedFilter: CompositeFilter, 
    mode: 'update' | 'create'
}